'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en-GB">
      <body className="flex min-h-screen flex-col items-center justify-center gap-4 bg-muted px-6 text-center text-foreground">
        <div className="max-w-lg space-y-3">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">VunaPay</p>
          <h1 className="text-2xl font-semibold">An unexpected fault occurred</h1>
          <p className="text-sm text-muted-foreground">
            We could not render this view safely. Retry the action or head back to the sign-in
            experience while our engineers investigate telemetry for this digest:{' '}
            <span className="font-mono text-xs">{error.digest ?? 'n/a'}</span>
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          <Button type="button" variant="primary" onClick={() => reset()}>
            Try again
          </Button>
          <Button type="button" variant="outline" onClick={() => router.replace('/login')}>
            Go to sign-in
          </Button>
        </div>
      </body>
    </html>
  );
}
